import { Component, OnInit } from '@angular/core';
import { ProductLiftChartComponent } from '../product-lift-chart/product-lift-chart.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { UtilityService } from '../../../../core/utility/services/utility.service';

@Component({
	selector: 'app-product-lift-chart-r11',
	templateUrl: './product-lift-chart-r11.component.html',
	styleUrls: ['../product-lift-chart/product-lift-chart.component.css']
})
export class ProductLiftChartR11Component extends ProductLiftChartComponent implements OnInit {
	public secondaryColor = '#d8d8d8';
	public tooltipOptions = {
		backgroundColor: '#fff',
		borderColor: this.secondaryColor,
		borderRadius: 5,
		useHTML: true,
		formatter: function () {
			if (this.series.name === 'Lift') {
				return (
					'<div style="text-align:center; padding: 2px">' +
					this.series.name +
					'<br/><b>' +
					this.y +
					'x </b><br/>' +
					this.x +
					'</div>'
				);
			} else if (this.series.name.includes('Rate')) {
				return (
					'<div style="text-align:center; padding: 2px">' +
					this.series.name +
					'<br/><b>' +
					this.y +
					'% </b><br/>' +
					this.x +
					'</div>'
				);
			} else {
				return (
					'<div style="text-align:center; padding: 2px">' +
					this.series.name +
					'<br/><b>' +
					this.y +
					' </b><br/>' +
					this.x +
					'</div>'
				);
			}
		}
	};
	public version: string;
	public isR9: boolean;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit() {
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
		super.ngOnInit();
		if (this.isR9) {
			this.tooltipOptions.backgroundColor = this.barchartconfiguration.tooltip.backgroundColor
				? this.barchartconfiguration.tooltip.backgroundColor
				: '#fff';
			this.tooltipOptions.borderRadius = this.barchartconfiguration.tooltip.borderRadius
			? this.barchartconfiguration.tooltip.borderRadius
				: 5;
		}
	}

	processResponseData() {
		this.campaignsList = this.campaignsList.map((campaignItem, index) => {
			const campaign = {
				name: campaignItem.campaign_name,
				id: campaignItem.campaign_id,
				campaign_id: campaignItem.campaign_id,
				average_lift: campaignItem.average_lift,
				average_baseline: campaignItem.average_baseline,
				average_exposed_rate: campaignItem.average_conversion_rate,
				graphData: [],
				xAxis: {},
				yAxisPrimary: {},
				legendLayout: {},
				title: {},
				subtitle: {}
			};
			const baseline_data = [];
			const exposed_rate = [];
			const lift_data = [];
			const xAxisObj: any = {};
			const categories = [];
			campaignItem.data.forEach((dataObj) => {
				if (dataObj.average_baseline.match(/^</)) {
					baseline_data.push({
						y: Number(dataObj.average_baseline.substr(1)),
						str: '&lt;'
					});
				} else {
					baseline_data.push({
						y: Number(dataObj.average_baseline),
						str: ''
					});
				}
				exposed_rate.push(Number(dataObj.average_conversion_rate));
				lift_data.push(this.buildLiftDataObject(dataObj));
				categories.push(dataObj.impression_date);
			});
			xAxisObj.labels = { rotation: -45 };
			xAxisObj.categories = categories;
			campaign.xAxis = xAxisObj;
			campaign.yAxisPrimary = {
				labels: {
					formatter: function () {
						return parseFloat(this.value).toFixed(2) + '%';
					},
					x: 20,
					align: 'right',
					style: {
						fontSize: '12px'
					}
				}
			};
			campaign['yAxisSecondary'] = {
				labels: {
					x: 5,
					style: {
						fontSize: '12px'
					},
					formatter: function () {
						return this.value + 'x';
					}
				},
				ceiling: 100
			};
			campaign['alignTicks'] = false;
			campaign.graphData = [
				{
					type: 'column',
					name: 'Lift',
					data: lift_data,
					color: this.isR9 ? this.getColorFromColorConfig(4, 1) : this.getColorFromColorConfig(0, 1),
					marker: {
						enabled: this.isR9 ? false : lift_data.length <= 1
					},
					yAxis: 0,
					index: lift_data.length <= 1 ? 0 : 2,
					legendIndex: 0
				},
				{
					type: this.isR9 ? 'spline' : 'area',
					name: 'Baseline Rate',
					data: baseline_data,
					useHTML: true,
					color: this.isR9 ? this.getColorFromColorConfig(0, 1) : this.getColorFromColorConfig(2, 1),
					fillColor: this.isR9 ? this.getColorFromColorConfig(0, 1) : this.getColorFromColorConfig(0),
					marker: {
						enabled: this.isR9 ? false : baseline_data.length <= 1
					},
					yAxis: 1,
					index: baseline_data.length <= 1 ? 2 : 0,
					legendIndex: 2
				},
				{
					type: this.isR9 ? 'spline' : 'area',
					name: 'Exposed Rate',
					data: exposed_rate,
					color: this.isR9 ? this.getColorFromColorConfig(3, 1) : this.getColorFromColorConfig(1, 1),
					fillColor: this.isR9 ? this.getColorFromColorConfig(3, 1) : this.getColorFromColorConfig(1),
					marker: {
						enabled: this.isR9 ? false : exposed_rate.length <= 1
					},
					yAxis: 1,
					index: 1,
					legendIndex: 1
				}
			];
			return campaign;
		});
		this.configGraphOptions();
	}

	public configGraphOptions() {
		this.campaignsList.forEach((campaign, index) => {
			campaign.legendLayout = {
				layout: 'horizontal',
				symbolHeight: 7,
				symbolWidth: 7,
				align: 'center',
				verticalAlign: 'bottom',
				floating: true,
				itemStyle: {
					fontSize: '12px',
					color: '#2e2e2e',
					fontWeight: 300
				}
				// reversed: true
			};
			campaign.title = {
				text: null
			};
			campaign.average_exposed_rate =
				UtilityService.isUndefinedOrNull(campaign.average_exposed_rate) || Number(campaign.average_exposed_rate) === 0
					? '<0.01'
					: campaign.average_exposed_rate;
			campaign.average_baseline =
				UtilityService.isUndefinedOrNull(campaign.average_baseline) || Number(campaign.average_baseline) === 0
					? '<0.01'
					: campaign.average_baseline;
			campaign.margin = [30, 110, 80, 110];
			if (this.isR9) {
				campaign.plotOptions = {
					series: {
						borderRadiusTopLeft: '50%',
						borderRadiusTopRight: '50%',
						pointWidth: 15
					}
				};
			} else {
				campaign.plotOptions = {
					series: {
						borderRadius: 6,
						pointWidth: 10
					}
				};
			}
			const titleObj = {
				offset: 0,
				useHTML: true,
				y: -15
			};
			campaign.xAxis.labels = {
				rotation: 0,
				style: {
					fontSize: '12px'
				}
			};
			campaign.yAxisPrimaryTitle = {
				...{},
				...titleObj,
				...{
					text: `<span class='xlabel'>Rate </span>`,
					rotation: 90,
					x: this.isR9 ? 50 : 30,
					style: {
						fontSize: '12px'
					}
				}
			};
			campaign.yAxisSecondaryTitle = {
				...{},
				...titleObj,
				...{
					text: `<span class='xlabel'> Lift </span>`,
					x: -30,
					rotation: 270,
					fontSize: '12px'
				}
			};
			campaign.height = this.barchartconfiguration.svgHeight ? this.barchartconfiguration.svgHeight : undefined;
		});
	}

	getToolTip() {
		this.campaignCarouselItem['tooltip'] = this.tooltipOptions;
	}
}
